import { Weight } from "src/Library/Types";

interface BasicObject {
  key: string;
  label: string;
}

interface ObjectIdNamePair {
  id: string;
  name: string;
}

interface ContainerList {
  key: Container;
  value?: string;
  label: Container;
  cargoList: string [];
}
interface ProductDetail {
  key: string;
  quantity?: number;
  unit?: string;
  skuClientNumber?: string;
  cases?: string;
  name?: string;
  productCnType?: string;
  productCnSize?: string;
}

interface CargoList {
  key: Cargo;
  label: Cargo;
  value: string;
  showAlways: boolean;
}

interface Cargo {
  cargo: string;
  product: string;
}

interface Container {
  type: string;
  size: string;
  volume?: Weight;
  weight?: Weight;
}

interface Ports {
  id: number | string;
  name: string;
  code: string;
  type: string;
  countryName: string;
  country_name: string;
  countryCode: string;
  country_code: string;
  flagS3Link: string;
  flag_s3_link: string;
  country: string;
  dbId?: string;
  city?: string;
  countryId?: string;
  country_id?: string;
  filterType?: string; //to understand if it's a portgroup or not
}

interface PortOrLocation extends Ports {
  state?: string;
}

interface Country {
  id: number;
  name: string;
  code: string;
  flagS3Link: string;
  countryName: string;
}

enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  INR = 'INR',
  JPY = 'JPY',
}

interface Range {
  min: number;
  max: number;
}

interface LabelValueObject {
  label: string;
  value: string;
}

interface Carriers {
  id: string;
  code: string;
  name: string;
}

type RfqChargeType = {
  currency?: string;
  amount?: number;
};

interface InchargeUser {
  name: string;
  email: string;
  phone: string;
};

interface File {
  name: string;
  url: string;
};

interface Address {
  id: string;
  locationType: string;
  name: string;
  country: string;
  addressTypes: string[];
  incharge: string;
  inchargeUser: { [key: string]: string };
  address: string;
  pincode: string;
  city: string;
  state: string;
  landmark: string;
  inchargeUserId: string;
  inchargeContactDetails: InchargeUser;
  stuffingPermissionDocument?: File;
  latitude?: string;
  longitude?: string;
  originPortId?: string;
  destinationPortId?: string;
  incoterm?: string;
};

interface FFAndGroup {
  key: string;
  label: string;
  isGroup: boolean;
};

interface IncotermToServices {
  [type: string]: {
    [incoterm: string]: {
      [mode: string]: {
        [location: string] : string[]
      }
    }
  }
}

export {
  BasicObject,
  ObjectIdNamePair,
  CargoList,
  ContainerList,
  ProductDetail,
  Cargo,
  Container,
  Ports,
  PortOrLocation,
  Currency,
  Range,
  LabelValueObject,
  Carriers,
  Country,
  RfqChargeType,
  FFAndGroup,
  Address,
  InchargeUser,
  File,
  IncotermToServices
};
